<template>
  <v-app>
    <header>
      <router-link to="/">
        <img src="../assets/logo.png" class="logo" alt="Yes Funds Logo" />
      </router-link>
    </header>

    <main>
      <div class="container">
        <div class="progress-container" v-if="vm.currentStep >= 1 && vm.currentStep <= 12">
          <v-progress-linear :value="progress" color="#14ba53" backgroundColor="#14ba5320" height="8" rounded></v-progress-linear>
        </div>

        <button :style="{ visibility: vm.showPrev ? 'visible' : 'hidden' }" @click="prevClick" class="previous-button"><i class="mdi mdi-arrow-left"></i> Previous</button>

        <transition name="slide" mode="out-in">
          <div class="step1 step" v-if="vm.currentStep == 1">
            <h2>What type of business do you own?</h2>
            <div class="buttons-container">
              <button class="selection-button" @click="step1Next('Corporation')" :class="{ selected: application.legalEntity == 'Corporation' }">
                <div class="img-container">
                  <img src="../assets/corp-icon.svg" />
                </div>
                <h3>Corporation</h3>
              </button>
              <button class="selection-button" @click="step1Next('Sole Proprietorship')" :class="{ selected: application.legalEntity == 'Sole Proprietorship' }">
                <div class="img-container">
                  <img src="../assets/sole-icon.svg" />
                </div>
                <h3>Sole Proprietor</h3>
              </button>

              <button class="selection-button" @click="step1Next('Limited Liability Company')" :class="{ selected: application.legalEntity == 'Limited Liability Company' }">
                <div class="img-container">
                  <img src="../assets/llc-icon.svg" />
                </div>
                <h3>Limited Liability Company (LLC)</h3>
              </button>

              <button class="selection-button" @click="step1Next('Partnership')" :class="{ selected: application.legalEntity == 'Partnership' }">
                <div class="img-container">
                  <img src="../assets/partnership-icon.svg" />
                </div>
                <h3>Partnership</h3>
              </button>

              <!-- <button class="selection-button" @click="step1Next('Other')" :class="{ selected: application.legalEntity == 'Other' }">
								<div class="img-container">
									<img src="../assets/other-icon.svg" />
								</div>
								<h3>Other</h3>
							</button> -->
            </div>
          </div>
        </transition>

        <transition name="slide" mode="out-in">
          <div class="step2 step" v-if="vm.currentStep == 2">
            <h2>What type of merchant are you?</h2>
            <div class="buttons-container">
              <button class="selection-button" @click="step2Next('Retail Sales')" :class="{ selected: application.merchantType == 'Retail Sales' }">
                <div class="img-container">
                  <img src="../assets/retail-icon.svg" />
                </div>
                <h3>Retail</h3>
              </button>
              <button class="selection-button" @click="step2Next('Food And Beverage')" :class="{ selected: application.merchantType == 'Food And Beverage' }">
                <div class="img-container">
                  <img src="../assets/restaurant-icon.svg" />
                </div>
                <h3>Restaurant</h3>
              </button>

              <button class="selection-button" @click="step2Next('Internet')" :class="{ selected: application.merchantType == 'Internet' }">
                <div class="img-container">
                  <img src="../assets/internet-icon.svg" />
                </div>
                <h3>Internet</h3>
              </button>

              <button class="selection-button" @click="step2Next('Other')" :class="{ selected: application.merchantType == 'Other' }">
                <div class="img-container">
                  <img src="../assets/other-icon.svg" />
                </div>
                <h3>Other</h3>
              </button>
            </div>
          </div>
        </transition>

        <transition name="slide" mode="out-in">
          <div class="step3 step" v-if="vm.currentStep == 3">
            <h2>What’s your business location?</h2>
            <div class="buttons-container">
              <button class="selection-button" @click="step3Next('Storefront')" :class="{ selected: application.businessLocation == 'Storefront' }">
                <div class="img-container">
                  <img src="../assets/storefront-icon.svg" />
                </div>
                <h3>Storefront</h3>
              </button>
              <button class="selection-button" @click="step3Next('Office')" :class="{ selected: application.businessLocation == 'Office' }">
                <div class="img-container">
                  <img src="../assets/office-icon.svg" />
                </div>
                <h3>Office</h3>
              </button>

              <button class="selection-button" @click="step3Next('Home')" :class="{ selected: application.businessLocation == 'Home' }">
                <div class="img-container">
                  <img src="../assets/home-icon.svg" />
                </div>
                <h3>Home</h3>
              </button>

              <button class="selection-button" @click="step3Next('Other')" :class="{ selected: application.businessLocation == 'Other' }">
                <div class="img-container">
                  <img src="../assets/other-icon.svg" />
                </div>
                <h3>Other</h3>
              </button>
            </div>
          </div>
        </transition>

        <transition name="slide" mode="out-in">
          <div class="step31 step" v-if="vm.currentStep == 4">
            <h2>How long have you been in business?</h2>
            <div class="buttons-container">
              <button class="selection-button" @click="step4Next('Less than 6 months')" :class="{ selected: application.businessDuration == 'Less than 6 months' }">
                <div class="img-container">
                  <h3>Less than 6 months</h3>
                </div>
              </button>
              <button class="selection-button" @click="step4Next('More than 6 months')" :class="{ selected: application.businessDuration == 'More than 6 months' }">
                <div class="img-container">
                  <h3>More than 6 months</h3>
                </div>
              </button>
            </div>
          </div>
        </transition>

        <transition name="slide" mode="out-in">
          <div class="step32 step" v-if="vm.currentStep == 5">
            <h2>How much does your business have in sales per month currently?</h2>
            <div class="buttons-container">
              <button class="selection-button" @click="step5Next('Less than $10,000')" :class="{ selected: application.lastMonthSales == 'Less than $10,000' }">
                <div class="img-container">
                  <h3>Less than $10,000</h3>
                </div>
              </button>
              <button class="selection-button" @click="step5Next('More than $10,0000')" :class="{ selected: application.lastMonthSales == 'More than $10,0000' }">
                <div class="img-container">
                  <h3>More than $10,0000</h3>
                </div>
              </button>
            </div>
          </div>
        </transition>

        <transition name="slide" mode="out-in">
          <div class="step32 step" v-if="vm.currentStep == 6">
            <h2>Please estimate your personal credit score?</h2>
            <div class="buttons-container">
              <button class="selection-button" @click="stepCreditScoreNext('Below 500 credit score')" :class="{ selected: application.creditScore == 'Below 500 credit score' }">
                <div class="img-container">
                  <h3>Below 500 credit score</h3>
                </div>
              </button>
              <button class="selection-button" @click="stepCreditScoreNext('Above 500 credit score')" :class="{ selected: application.creditScore == 'Above 500 credit score' }">
                <div class="img-container">
                  <h3>Above 500 credit score</h3>
                </div>
              </button>
            </div>
          </div>
        </transition>

        <transition name="slide" mode="out-in">
          <div class="step32 step" v-if="vm.currentStep == 7">
            <h2>Does your business have a Federal Tax Identification Number?</h2>
            <div class="buttons-container">
              <button class="selection-button" @click="taxIDNext(true)" :class="{ selected: application.hasFederalTaxID == true }">
                <div class="img-container">
                  <h3>Yes</h3>
                </div>
              </button>
              <button class="selection-button" @click="taxIDNext(false)" :class="{ selected: application.hasFederalTaxID == false }">
                <div class="img-container">
                  <h3>No</h3>
                </div>
              </button>
            </div>
          </div>
        </transition>

        <transition name="slide" mode="out-in">
          <div class="step4 step" v-if="vm.currentStep == 8">
            <h2>What is the funding amount requested?</h2>
            <!-- <v-slider v-model="vm.loanAmount" :tick-labels="['$10K', '$20K', '$30K', '$50K', '$75K', '$100K', '$150K', '> $150K']" :min="0" :max="7"></v-slider> -->
            <h1 class="loan-amount">{{ formattedLoanAmount }}</h1>

            <div class="slider-container">
              <p style="margin-right: 20px;">$20,000</p>
              <v-slider v-model="application.loanAmount" :min="20000" :max="2000000" :step="5000" :height="60" track-fill-color="#14ba53" track-color="#14ba5325" thumb-color="#6ecd86"></v-slider>
              <p style="margin-left: 20px;">$2,000,000+</p>
            </div>
            <transition name="expand" mode="out-in">
              <v-form ref="amountForm" @submit.prevent>
                <div class="custom-amount" v-if="application.loanAmount == 2000000">
                  <v-text-field v-model="application.customLoanAmount" v-currency="vm.currencyOptions" :rules="minVal" label="Funding amount" required outlined hide-details="false" :lazy-validation="true">
                  </v-text-field>
                </div>
              </v-form>
            </transition>
          </div>
        </transition>

        <transition name="slide" mode="out-in">
          <div class="step41 step" v-if="vm.currentStep == 9">
            <h2>Contact information</h2>

            <v-form ref="emailForm" @submit.prevent>
              <!-- <v-text-field v-model="application.userEmail" :rules="emailRules" label="Email Address" required outlined hide-details="false"></v-text-field> -->
              <div class="col col1">
                <v-text-field v-model="vm.ownerFirstName" :rules="mandatoryRule" label="First Name" required outlined hide-details="false"></v-text-field>
                <v-text-field v-model="vm.ownerLastName" :rules="mandatoryRule" label="Last Name" required outlined hide-details="false"></v-text-field>
                <v-text-field v-model="application.ownerEmail" :rules="emailRules" label="Your Email Address" required outlined hide-details="false" type="email"></v-text-field>
                <v-text-field type="tel" v-model="VMOwnerPhoneNumber" :rules="phoneRules" label="Your Phone Number" required outlined hide-details="false"></v-text-field>
              </div>
            </v-form>
          </div>
        </transition>

        <transition name="slide" mode="out-in">
          <div class="step5 step" v-if="vm.currentStep == 10">
            <h2>Business information</h2>

            <!-- v-model="vm.businessFormValid" -->
            <v-form ref="businessForm" @submit.prevent>
              <div class="col col1">
                <v-text-field v-model="application.businessLegalName" :rules="mandatoryRule" label="Business Legal Name" required outlined hide-details="false"></v-text-field>
                <v-text-field v-model="application.businessDBAName" :rules="mandatoryRule" label="Business DBA Name" required outlined hide-details="false">></v-text-field>

                <v-text-field v-model="application.businessStreetAddress" :rules="mandatoryRule" label="Business Street Address" required outlined hide-details="false"></v-text-field>
                <v-text-field type="tel" v-model="application.businessZip" :loading="vm.businessZipLoading" :rules="mandatoryRule" label="Business Zip" required outlined hide-details="false"></v-text-field>
                <v-text-field v-model="application.businessCity" :loading="vm.businessZipLoading" :rules="mandatoryRule" label="Business City" required outlined hide-details="false"></v-text-field>
                <v-text-field v-model="application.businessState" :loading="vm.businessZipLoading" :rules="mandatoryRule" label="Business State" required outlined hide-details="false"></v-text-field>
              </div>
              <div class="col col2">
                <v-text-field type="tel" v-model="VMBusinessPhoneNumber" :rules="phoneRules" label="Business Phone Number" required outlined hide-details="false"></v-text-field>
                <v-text-field type="url" v-model="application.businessWebsite" :rules="mandatoryRule" label="Business Website" required outlined hide-details="false"></v-text-field>
                <v-menu ref="businessStartDateMenuRef" v-model="vmbusinessStartDateShow" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="vm.businessStartDateFormatted" label="Business Start Date" readonly v-on="on" :rules="mandatoryRule" outlined hide-details="false"></v-text-field>
                  </template>
                  <v-date-picker ref="businessStartDatePickerRef" v-model="application.businessStartDate" :max="new Date().toISOString().substr(0, 10)" min="1900-01-01" @change="vmbusinessStartDateSave"></v-date-picker>
                </v-menu>

                <!-- <v-text-field v-model="application.productsSold" :rules="mandatoryRule" label="Products / Services Sold" required outlined hide-details="false">></v-text-field> -->

                <!-- <p style="margin: 20px 0 6px 0; color: #737373;">Do you have a Federal Tax ID (EIN)?</p> -->

                <!-- <v-radio-group row style="padding: 0; min-height: 0; margin: 0" v-model="application.hasFederalTaxID" hide-details="false">
									<v-radio label="Yes" :value="true"></v-radio>
									<v-radio label="No" :value="false"></v-radio>
								</v-radio-group> -->
                <v-text-field v-model="vmFederalTaxID" :rules="taxIdRules" @input="taxIdHyphenNudge" label="Federal Tax ID (EIN) - (Optional)" outlined hide-details="false">></v-text-field>
              </div>
            </v-form>
          </div>
        </transition>

        <transition name="slide" mode="out-in">
          <div class="step6 step" v-if="vm.currentStep == 11">
            <h2>Owner information</h2>

            <!-- v-model="vm.ownerFormValid" -->
            <v-form ref="ownerForm" @submit.prevent>
              <div class="col col1">
                <!-- <v-text-field v-model="application.ownerName" :rules="mandatoryRule" label="Owner Name" required outlined hide-details="false"></v-text-field> -->
                <!-- <v-text-field v-model="application.ownerEmail" :rules="emailRules" label="Owner Email Address" required outlined hide-details="false" type="email"></v-text-field> -->
                <!-- <v-text-field v-model="application.ownerPercentage" :rules="mandatoryRule" label="Owner Percentage" required outlined hide-details="false" type="number"></v-text-field> -->

                <v-select class="mobile" style="visibility: hidden; margin-bottom: 0 !important;" outlined hide-details="false"></v-select>

                <v-select v-model="application.ownerPercentage" :items="vm.percentages" label="Owner Percentage" :rules="mandatoryRule" required outlined hide-details="false"></v-select>

                <v-menu ref="ownerDOBMenuRef" v-model="vmownerDOBShow" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="vm.ownerDOBFormatted" label="Owner Date of Birth" readonly v-on="on" :rules="mandatoryRule" required outlined hide-details="false"></v-text-field>
                  </template>
                  <v-date-picker ref="ownerDOBPickerRef" v-model="application.ownerDOB" :max="getMinAge()" min="1920-01-01" @change="vmownerDOBSave"></v-date-picker>
                </v-menu>

                <v-text-field type="tel" v-model="application.ownerSSN" :rules="mandatoryRule" label="Owner Social Security Number" required outlined hide-details="false"></v-text-field>

                <!-- <v-select
									v-model="application.reasonForLoan"
									:items="[
										'Expansion',
										'Equipment purchase',
										'Purchase a vehicle',
										'Inventory',
										'Import goods',
										'Payroll',
										'Marketing',
										'Commercial real estate',
										'Remodel my location',
										'Refinance debt',
										'Finance accounts receivable',
										'Buy a franchise',
										'Buy a business',
										'Buy out a partner',
										'Taxes',
										'Insurance',
										'Working capital',
										'Other',
									]"
									label="Reason for Cash Advance"
									:rules="mandatoryRule"
									required
									outlined
									hide-details="false"
								></v-select> -->
              </div>
              <div class="col col2">
                <v-checkbox style="margin-bottom: 0 !important;" v-model="vm.useSameInfo" label="Use business info?" outlined hide-details="false" class="checkbox"></v-checkbox>
                <v-text-field v-model="application.ownerStreetAddress" :rules="mandatoryRule" label="Owner Street Address" required outlined hide-details="false"></v-text-field>
                <v-text-field type="tel" v-model="application.ownerZip" :loading="vm.ownerZipLoading" :rules="mandatoryRule" label="Owner Zip" required outlined hide-details="false"></v-text-field>
                <v-text-field v-model="application.ownerCity" :loading="vm.ownerZipLoading" :rules="mandatoryRule" label="Owner City" required outlined hide-details="false"></v-text-field>
                <v-text-field v-model="application.ownerState" :loading="vm.ownerZipLoading" :rules="mandatoryRule" label="Owner State" required outlined hide-details="false"></v-text-field>
                <!-- <v-text-field type="tel" v-model="application.ownerPhoneNumber" :rules="mandatoryRule" label="Owner Phone Number" required outlined hide-details="false"></v-text-field> -->
              </div>
            </v-form>
          </div>
        </transition>

        <transition name="slide" mode="out-in">
          <div class="step7 step" v-if="vm.currentStep == 12">
            <h2>Sign Your Application</h2>
            <!--
						<p><a style="color: rgba(0, 0, 0, 0.87)" href="#" @click="preview">Click here to review your application.</a></p>
						-->

            <p style="font-size: 14px;">
              By signing below, the Merchant and its owners/principals: (1) certify that all information and documents submitted in connection with this Application is true, correct and complete; (2) authorize Yesfunds,
              its agents, partners, and lenders to receive credit reports and any other information regarding the merchant and its owners and principals from third parties, to verify and information provided on the
              Application; and (3) to receive an occasional promotion offer by email or fax.
            </p>
            <v-form ref="sigForm" @submit.prevent>
              <div class="col">
                <v-text-field v-model="application.signedBy" :rules="mandatoryRule" label="Signer Name" required outlined hide-details="false"></v-text-field>

                <v-text-field v-model="VMSignedOn" label="Date" readonly outlined hide-details="false"></v-text-field>

                <!--
								<v-checkbox v-model="vm.useNameAsSig" label="Click to sign"></v-checkbox>
								<h3 v-if="vm.useNameAsSig" style="font-family: Caveat; font-size:40px; background: #FFF; padding: 20px 30px; border: 1px solid #a8a8a8; border-radius: 4px">{{ application.signedBy }}</h3>
 								-->

                <div v-if="!vm.useNameAsSig">
                  <p style="color: #707070;">Sign in the box below using your finger or mouse. By siging below you agree to the above disclosure.</p>
                  <div class="signature-outer">
                    <label :class="{ emptySig: !vm.sigFormValid }">Sign Here</label>
                    <VueSignaturePad id="canvas" height="200px" ref="signaturePad" class="canvas-container" :class="{ emptySig: !vm.sigFormValid }" :options="{ backgroundColor: 'rgb(255, 255, 255)' }" />
                    <hr />
                  </div>

                  <div class="undo-container">
                    <v-row justify="space-between" class="undo-container">
                      <!-- <p class="error-text" v-if="!vm.sigFormValid">This field is required</p> -->
                      <button type="button" style="margin-left: auto;" @click="undo">Undo</button>
                    </v-row>
                  </div>
                </div>
              </div>
            </v-form>
          </div>
        </transition>

        <transition name="slide" mode="out-in">
          <div class=" step-success" v-if="vm.currentStep == 13">
            <div v-if="vm.successToast">
              <h1>Thank you!</h1>
              <p style="margin-top: 16px;">Your application has been submitted successfully. Someone will be in touch with you to update you on your application status shortly!</p>

              <p style="margin-top: 16px;">We will send a copy of your application to your email address. If you don't see it come through to your inbox, please check your spam folder to be safe.</p>
              <br />
              <p>Would you like to download your application?</p>
              <a :href="vm.downloadUrl" style="color: #fff;" class="main-btn download-btn" target="_blank" download>Download</a>
            </div>

            <div v-if="vm.errorToast">
              <h2>Error</h2>
              Unexpected error occured while saving your data. Please try again later.
              <div>
                <router-link to="/" class="main-btn" style="display: inline-block; text-decoration: none; color: #fff;">Back to Home</router-link>
              </div>
            </div>
          </div>
        </transition>

        <div class="loading">
          <v-overlay :value="vm.isLoading">
            <v-btn icon @click="loading = false">
              <div class="text-center">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </div>
            </v-btn>
          </v-overlay>
        </div>

        <button type="button" :style="{ display: vm.showNext ? 'block' : 'none' }" @click="nextClick" class="main-btn">{{ vm.currentStep == 12 ? "Submit" : "Continue" }}</button>

        <div v-if="vm.currentStep == 9" style="font-size: 14px; color: #707070; width: 500px; max-width: 100%; margin: 50px auto 20px auto;">
          <label>
            By clicking Continue, you agree we at Yesfunds may send you offers and other information to the number and email you entered above, including through the possible use of automated technology, SMS and
            pre-recorded messages. You are not required to consent as you can always call us instead. To stop receiving text messages, reply "Stop". You may view our Privacy Policy
            <a style="color: #707070;" href="/privacy-policy" target="_blank">here</a>.
          </label>
        </div>

        <!-- <pre>{{ application }}</pre> -->
      </div>

      <v-dialog v-model="vm.dialog" persistent width="400px" max-width="90%" content-class="closeDialog">
        <v-card>
          <v-card-title class="headline">
            <img src="../assets/logo.png" class="logo" alt="Yes Funds Logo" />
          </v-card-title>
          <v-card-text>
            <p>{{ vm.dialogMessage }}</p>
            <p>Thanks and have a great day.</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#14ba53" text @click="close">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </main>
    <footer>
      <div class="container">
        <p>
          All funding is subject to financier's approval. We are not a lender and we do not make loans, loan commitments or lock rates. We are merely a marketing and matchmaking service. If you are interested, you will
          be referred to Redwood Growth Capital who will propose a funding agreement or other alternative funding to you. We do not quote funding terms or arrange for the same. All of our offers are void where prohibited
          by law. The information we provide does not constitute legal, tax, financial or accounting advice, and should not be considered a substitute for obtaining competent personalized advice from a licensed
          professional. You should seek professional advice before making any decision that could affect your financial health. All credit decisions, including funding approval and the conditional rates and terms you are
          offered, are the responsibility of the participating funding companies and will vary based upon your amount requested, your particular financial situation, and criteria determined by the partners to whom you
          are matched. Repayment terms may vary, and can range from 3 months to 18 months. Not all consumers will qualify for the advertised rates and terms.
        </p>

        <span style="display: block; text-align: center;">
          <router-link to="/privacy-policy" target="_blank">Privacy Policy</router-link>
        </span>

        <p class="copy-rights">© {{ new Date().getFullYear() }}, Yesfunds, All Rights Reserved.</p>
      </div>
    </footer>
  </v-app>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueSignaturePad from "vue-signature-pad";
import "@/styles/application.scss";
var _axios = axios.create();

Vue.use(VueSignaturePad);
import { parseCurrency } from "vue-currency-input";

export default {
  mounted() {
    fbq("track", "InitiateCheckout");

    window.addEventListener("unload", this.saveProgressOnClose, false);

    window.onbeforeunload = () => {
      if (this.vm.currentStep <= 12) {
        return "Do you really want to leave? your application will not be saved.";
      }
    };
  },
  data: () => ({
    application: {
      uid: null,
      legalEntity: null,
      merchantType: null,
      businessLocation: null,
      businessDuration: null,
      lastMonthSales: null,
      creditScore: null,
      loanAmount: 100000,
      customLoanAmount: 2000000,
      businessLegalName: null,
      businessDBAName: null,
      businessStreetAddress: null,
      businessCity: null,
      businessState: null,
      businessZip: null,
      businessPhoneNumber: null,
      businessWebsite: null,
      hasFederalTaxID: null,
      federalTaxID: null,
      businessStartDate: null,
      // productsSold: null,
      ownerName: null,
      ownerStreetAddress: null,
      ownerCity: null,
      ownerState: null,
      ownerZip: null,
      ownerPhoneNumber: null,
      ownerEmail: null,
      ownerPercentage: null,
      ownerDOB: null,
      ownerSSN: null,
      // reasonForLoan: null,
      signedBy: null,
    },

    vm: {
      currentStep: 1,
      showNext: false,
      showPrev: false,
      // businessStartDateShow: false,
      // ownerDOBShow: false,
      businessFormValid: true,
      ownerFormValid: true,
      successToast: false,
      errorToast: false,
      sigFormValid: true,
      isLoading: false,
      downloadUrl: "",
      useSameInfo: false,
      businessZipLoading: false,
      ownerZipLoading: false,
      businessStartDateFormatted: null,
      ownerDOBFormatted: null,
      useNameAsSig: false,
      leadSaved: false,
      percentages: [
        "100%",
        "99%",
        "98%",
        "97%",
        "96%",
        "95%",
        "94%",
        "93%",
        "92%",
        "91%",
        "90%",
        "89%",
        "88%",
        "87%",
        "86%",
        "85%",
        "84%",
        "83%",
        "82%",
        "81%",
        "80%",
        "79%",
        "78%",
        "77%",
        "76%",
        "75%",
        "74%",
        "73%",
        "72%",
        "71%",
        "70%",
        "69%",
        "68%",
        "67%",
        "66%",
        "65%",
        "64%",
        "63%",
        "62%",
        "61%",
        "60%",
        "59%",
        "58%",
        "57%",
        "56%",
        "55%",
        "54%",
        "53%",
        "52%",
        "51%",
        "50%",
        "49%",
        "48%",
        "47%",
        "46%",
        "45%",
        "44%",
        "43%",
        "42%",
        "41%",
        "40%",
        "39%",
        "38%",
        "37%",
        "36%",
        "35%",
        "34%",
        "33%",
        "32%",
        "31%",
        "30%",
        "29%",
        "28%",
        "27%",
        "26%",
        "25%",
        "24%",
        "23%",
        "22%",
        "21%",
        "20%",
        "19%",
        "18%",
        "17%",
        "16%",
        "15%",
        "14%",
        "13%",
        "12%",
        "11%",
        "10%",
        "9%",
        "8%",
        "7%",
        "6%",
        "5%",
        "4%",
        "3%",
        "2%",
        "1%",
      ],
      currencyOptions: { currency: "USD", distractionFree: false, allowNegative: false, precision: 0, valueAsInteger: true, valueRange: { min: 2000000 } },
      ownerFirstName: '',
      ownerLastName: '',


      dialog: false,
      dialogMessage: "",
    },

    VMBusinessPhoneNumber: null,
    VMOwnerPhoneNumber: null,
    vmbusinessStartDateShow: false,
    vmownerDOBShow: false,
    vmFederalTaxID: '',

    mandatoryRule: [(v) => !!v || "This field is required"],
    emailRules: [(v) => !!v || "This field is required", (v) => /.+@.+\..+/.test(v) || "E-mail must be valid"],
    phoneRules: [(v) => !!v || "This field is required", (v) => /^[0-9]{3}[.]?[-]?[0-9]{3}[.]?[-]?[0-9]{4}$/.test(v) || "Phone number must be 10 digits"],
    taxIdRules: [(v) => !v || /^\d{2}-\d{7}$/.test(v) || "Federal Tax ID number must be valid!"],
    minVal: [
      (v) => !!v || "This field is required",
      (v) => {
        let val = parseCurrency(v, { currency: "USD", distractionFree: false, allowNegative: false, precision: 0, valueAsInteger: true });
        return val > 2000000 || "Value must be more than $2,000,000";
      },
    ],
  }),

  computed: {
    VMCurrentStep() {
      return this.vm.currentStep;
    },

    progress() {
      return Math.round((this.vm.currentStep / 12) * 100);
    },

    formattedLoanAmount() {
      if (this.application.loanAmount < 2000000) {
        this.application.customLoanAmount = 2000000;
      }

      if (this.application.loanAmount == 2000000) {
        return "" + this.application.customLoanAmount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } else {
        return "$" + this.application.loanAmount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    },

    businessZip() {
      return this.application.businessZip;
    },

    ownerZip() {
      return this.application.ownerZip;
    },

    VMUseSameInfo() {
      return this.vm.useSameInfo;
    },

    VMBusinessStartDate() {
      return this.application.businessStartDate;
    },

    VMOwnerDOB() {
      return this.application.ownerDOB;
    },
    VMSigMandatoryRule() {
      if (!this.vm.useNameAsSig && this.$refs.signaturePad) {
        const { isEmpty } = this.$refs.signaturePad.saveSignature("image/jpeg");
        if (isEmpty) return ["This field is required."];
      }
    },

    VMSignedOn() {
      return new Date().toLocaleDateString("us-en").replaceAll("/", "-");
    },
  },

  watch: {
    VMBusinessStartDate(val) {
      this.vm.businessStartDateFormatted = this.formatDate(this.application.businessStartDate);
    },
    VMOwnerDOB(val) {
      this.vm.ownerDOBFormatted = this.formatDate(this.application.ownerDOB);
    },

    VMCurrentStep() {
      this.vm.showPrev = false;
      this.vm.showNext = false;

      if (this.vm.currentStep >= 2 && this.vm.currentStep <= 12) {
        this.vm.showPrev = true;
      }

      if (this.vm.currentStep >= 8 && this.vm.currentStep <= 12) {
        this.vm.showNext = true;
      }
    },

    VMOwnerPhoneNumber(val) {
      if (val) this.application.ownerPhoneNumber = val.replace(/[-]/g, "").replace(/[.]/g, "");
    },

    VMBusinessPhoneNumber(val) {
      if (val) this.application.businessPhoneNumber = val.replace(/[-]/g, "").replace(/[.]/g, "");
    },

    async businessZip() {
      if (this.businessZip.length == 5) {
        this.vm.businessZipLoading = true;
        const result = await _axios.get("https://ZiptasticAPI.com/" + this.businessZip);
        if (result && result.data && result.data.state && result.data.city) {
          this.application.businessState = result.data.state;
          this.application.businessCity = result.data.city;
        }
        this.vm.businessZipLoading = false;
      }
    },

    async ownerZip() {
      if (this.ownerZip.length == 5) {
        this.vm.ownerZipLoading = true;
        const result = await _axios.get("https://ZiptasticAPI.com/" + this.ownerZip);
        if (result && result.data && result.data.state && result.data.city) {
          this.application.ownerState = result.data.state;
          this.application.ownerCity = result.data.city;
        }
        this.vm.ownerZipLoading = false;
      }
    },

    VMUseSameInfo() {
      if (this.vm.useSameInfo === true) {
        this.application.ownerZip = this.application.businessZip;
        this.application.ownerState = this.application.businessState;
        this.application.ownerCity = this.application.businessCity;
        this.application.ownerStreetAddress = this.application.businessStreetAddress;
      }
    },

    vmbusinessStartDateShow(val) {
      val && setTimeout(() => (this.$refs.businessStartDatePickerRef.activePicker = "YEAR"));
    },

    vmownerDOBShow(val) {
      val && setTimeout(() => (this.$refs.ownerDOBPickerRef.activePicker = "YEAR"));
    },

    vmFederalTaxID: (val)=>{}
  },

  methods: {
    getMinAge() {
      var date = new Date();
      date.setFullYear(date.getFullYear() - 18);
      return date.toISOString().substr(0, 10);
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },
    prevClick() {
      this.vm.currentStep--;
      this.scrollToTop();
    },

    // doSign() {
    // 	var c = document.querySelector("canvas");

    // 	var ctx = c.getContext("2d");
    // 	ctx.canvas.width = ctx.canvas.width;

    // 	ctx.beginPath();
    // 	ctx.rect(0, 0, c.width, c.height);
    // 	ctx.fillStyle = "white";
    // 	ctx.fill();
    // 	if (this.vm.useNameAsSig) {
    // 		// ctx.font = '50px "Comic Sans MS"';
    // 		ctx.font = '50px "Parisienne"';
    // 		ctx.fillStyle = "black";

    // 		if (this.application.signedBy) {
    // 			ctx.fillText(this.application.signedBy, 20, 100);
    // 		}
    // 	}
    // },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return [month, day, year].join("-");
    },

    vmbusinessStartDateSave(date) {
      this.$refs.businessStartDateMenuRef.save(date);
    },

    vmownerDOBSave(date) {
      this.$refs.ownerDOBMenuRef.save(date);
    },

    async nextClick() {
      this.scrollToTop();

      if (this.vm.currentStep == 8) {
        fbq("track", "AddToWishlist");
        if (this.$refs.amountForm.validate()) {
          this.vm.currentStep++;
        }
      } else if (this.vm.currentStep == 9) {
        if (this.$refs.emailForm.validate()) {
          this.application.ownerName = this.vm.ownerFirstName + ' ' + this.vm.ownerLastName;
          this.saveLead();
          this.saveProgressOnStep();
//console.log('ownerName');
//console.log(this.application.ownerName);
          this.vm.currentStep++;
        }
      } else if (this.vm.currentStep == 10) {
        if (this.$refs.businessForm.validate()) {
          this.application.federalTaxID = this.vmFederalTaxID;
          fbq("track", "AddPaymentInfo");
          this.saveProgressOnStep();
//console.log(this.application.federalTaxID);
          this.vm.currentStep++;
        }
      } else if (this.vm.currentStep == 11) {
        if (this.$refs.ownerForm.validate()) {
          this.saveProgressOnStep();
          fbq("track", "AddToCart");
          this.vm.currentStep++;
        }
      } else if (this.vm.currentStep == 12) {
        try {
          if (!this.vm.useNameAsSig) {
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature("image/jpeg");
            if (!this.$refs.sigForm.validate() || (isEmpty && !this.vm.useNameAsSig)) {
              if (isEmpty) this.vm.sigFormValid = false;
              return;
            }
            this.application.attachment = data;
          } else {
            if (!this.$refs.sigForm.validate()) {
              return;
            }
          }

          // if (isEmpty && !this.vm.useNameAsSig) {
          // 	this.vm.sigFormValid = false;
          // }

          this.vm.isLoading = true;
          let formData = new FormData();
          if (!this.vm.useNameAsSig) {
            const blob = this.dataURItoBlob(this.application.attachment);
            formData.append(`files.attachment`, blob, "signature");
          }
          formData.append("data", JSON.stringify(this.getApp()));

          let res = await axios.post("/applications", formData);
          this.vm.downloadUrl = axios.defaults.baseURL + "/attachments/" + res.data.uid + ".pdf";
          fbq("track", "CompleteRegistration");
          this.vm.currentStep++;
          this.vm.isLoading = false;
          this.vm.successToast = true;
        } catch (err) {
          this.vm.currentStep++;
          this.vm.isLoading = false;
          this.vm.errorToast = true;
          console.log(err);
        }
      } else {
        this.vm.currentStep++;
      }
    },

    getApp() {
      let amount = this.application.loanAmount >= 2000000 ? this.$parseCurrency(this.formattedLoanAmount, this.vm.currencyOptions) : this.application.loanAmount;
      return { ...this.application, loanAmount: amount };
    },
    async preview() {
      try {
        this.vm.isLoading = true;

        let res = await axios.post("/applications/preview", this.getApp());
        if (res.data) {
          console.log(axios.defaults.baseURL + "/preview/" + res.data + ".pdf");

          // window.open(axios.defaults.baseURL + "/preview/" + res.data + ".pdf", "_blank");

          let anotherWindow = window.open("");
          anotherWindow.location = axios.defaults.baseURL + "/preview/" + res.data + ".pdf";
        } else {
          throw "cannot preview";
        }

        this.vm.isLoading = false;
        this.vm.successToast = true;
      } catch (err) {
        this.vm.isLoading = false;
        this.vm.errorToast = true;
        console.log(err);
      }
    },

    saveLead() {
      try {
        if (!this.vm.leadSaved) {
          let app = this.getApp();
          let lead = { name: app.ownerName, email: app.ownerEmail, phone: app.ownerPhoneNumber, loanAmount: app.loanAmount };
          axios.post("/leads/", lead);
          fbq("track", "Lead");
          this.vm.leadSaved = true;
        }
      } catch (err) {}
    },

    step1Next(val) {
      this.scrollToTop();
      this.application.legalEntity = val;
      setTimeout(() => {
        this.vm.currentStep++;
      }, 100);
    },

    step2Next(val) {
      this.scrollToTop();
      this.application.merchantType = val;
      setTimeout(() => {
        this.vm.currentStep++;
      }, 100);
    },

    step3Next(val) {
      this.scrollToTop();
      this.application.businessLocation = val;
      setTimeout(() => {
        this.vm.currentStep++;
      }, 100);
    },

    step4Next(val) {
      if (val == "Less than 6 months") {
        this.vm.dialogMessage = "Sorry we can only help businesses that have been established for 6 months or longer. Please reapply when you hit that milestone.";
        this.vm.dialog = true;
      } else {
        this.scrollToTop();
        this.application.businessDuration = val;
        setTimeout(() => {
          this.vm.currentStep++;
        }, 100);
      }
    },

    step5Next(val) {
      if (val == "Less than $10,000") {
        this.vm.dialogMessage = "Sorry we can only help businesses that have sales of $10,000 or more per month. Please reapply when you hit that milestone.";
        this.vm.dialog = true;
      } else {
        this.scrollToTop();
        this.application.lastMonthSales = val;
        setTimeout(() => {
          this.vm.currentStep++;
        }, 100);
      }
    },

     stepCreditScoreNext(val) {
       if (val == "Below 500 credit score") {
         this.vm.dialogMessage = "Sorry we can only help businesses with an owner that has a personal credit score of 500 or higher. Please reapply when you hit that milestone.";
         this.vm.dialog = true;
       } else {
         this.scrollToTop();
         this.application.creditScore = val;
         setTimeout(() => {
           this.vm.currentStep++;
         }, 100);
       }
     },

     taxIdHyphenNudge(taxid) {
        if(taxid.length === 2){
          this.vmFederalTaxID = taxid + '-';
        }
     },

    taxIDNext(val) {
      if (val == false) {
        this.vm.dialogMessage = "Sorry we can only help businesses that have a Federal Tax Identification Number. Please reapply when you have a Federal Tax Identification Number.";
        this.vm.dialog = true;
      } else {
        this.scrollToTop();
        this.application.hasFederalTaxID = val;
        setTimeout(() => {
          this.vm.currentStep++;
        }, 100);
      }
    },

    undo() {
      this.$refs.signaturePad.undoSignature();
    },

    dataURItoBlob(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(",")[0].indexOf("base64") >= 0) byteString = atob(dataURI.split(",")[1]);
      else byteString = unescape(dataURI.split(",")[1]);

      // separate out the mime component
      var mimeString = dataURI
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], { type: mimeString });
    },

    closeDialog(shallClose) {
      this.vm.exitDialog = false;
    },

    async saveProgressOnClose() {
      // await axios.post("/applications/save-progress", this.getApp());
      if (this.vm.currentStep >= 10 && this.vm.currentStep <= 12) {
        await navigator.sendBeacon(axios.defaults.baseURL + "/applications/save-progress?json=0", JSON.stringify(this.getApp()));
      }

      return "Do you really want to leave? your application will not be saved.";
    },

    async saveProgressOnStep() {
      const response = await axios.post("/applications/save-progress?json=1", this.getApp());
      if (response && response.status) {
        this.application.uid = response.data;
      }
    },

    close() {
      window.removeEventListener("unload", this.saveProgressOnClose);
      window.onbeforeunload = null;
      window.location = "/";
    },
  },

  beforeRouteLeave(to, from, next) {
    // this.vm.exitDialog = true;
    // if (this.dialogResponse) {
    // 	next();
    // } else {
    // 	next(false);
    // }
    if (this.vm.currentStep >= 2 && this.vm.currentStep <= 12) {
      const answer = window.confirm("Do you really want to leave? your application will not be saved.");
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
};
</script>
<style lang="scss" scoped>
.container {
  max-width: 1185px !important;
}
</style>

<style>
button {
  outline: none !important;
}
.application {
  width: 90%;
  max-width: 600px;
  margin: auto;
}

.signature-outer {
  position: relative;
  width: 100%;
  height: 200px;
  padding-bottom: 200px;
}

#canvas {
  position: relative;
  width: 100%;
  height: 100%;
}

.sig-title {
  color: #14ba53;
  text-align: center;
  margin: 30px 0 10px 0;
}

.slide-enter-active {
  animation: slide-in 200ms ease-in-out forwards;
}

.expand-enter-active {
  animation: expand-in 200ms ease-in-out forwards;
}

.expand-leave-active {
  animation: expand-out 200ms ease-in-out forwards;
}
/* .slide-leave-active {
	animation: slide-out 0ms ease-in-out forwards;
} */

@keyframes slide-in {
  from {
    transform: translateX(100px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes expand-in {
  from {
    transform: translateY(-30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes expand-out {
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-30px);
    opacity: 0;
  }
}
</style>
